import React from "react";
import ReactDOM from "react-dom";
import PriipForm from "./PriipForm.js";
import "babel-polyfill";
import "../css/priip-style.css";

window.RenderApp = function RenderApp(configuration) {
  ReactDOM.render(
    <Priip configuration={configuration} />,
    document.getElementById("priip")
  );
};

export class Priip extends React.Component {
  render() {
    return <PriipForm configuration={this.props.configuration} />;
  }
}

window.RenderApp(configuration);



// WEBPACK FOOTER //
// ./src/js/App.js